import { CompassRoleEntity } from 'src/types/entities/CompassRole'
import { CompassRolesResponse } from 'src/types/generated'

export const CompassRoleTranslator = {
  toEntities: (response: CompassRolesResponse): CompassRoleEntity[] => {
    return (
      response.compassRoles?.map(compassRole => {
        return {
          id: compassRole.id,
          name: compassRole.name,
          displayName: compassRole.displayName,
          priority: compassRole.priority,
        }
      }) ?? []
    )
  },
} as const
